<template>
  <main class="container mx-auto px-4 md:px-6 py-4 md:py-8">
    <div class="space-y-6">
      <!-- Mobile Stats Toggle Button -->
      <div class="lg:hidden">
        <button 
          @click="showStats = !showStats" 
          class="w-full glass-card rounded-lg p-4 text-white flex items-center justify-between hover:bg-white/10 transition-colors"
        >
          <span class="font-semibold">Statistik anzeigen</span>
          <i :class="showStats ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" class="text-white/70"></i>
        </button>
      </div>
      
      <!-- Stats Cards - Hidden on mobile, shown on desktop or when toggled -->
      <div v-show="showStats" class="lg:hidden">
        <StatsCards :stats="stats" />
      </div>
      
      <!-- Stats Cards - Always visible on desktop -->
      <div class="hidden lg:block">
        <StatsCards :stats="stats" />
      </div>
      
      <GuestList 
    :guests="guests" 
    :is-refreshing="isRefreshing"
    @check-in="handleCheckIn" 
    @reset-guest="handleResetGuest"
    @delete-guest="handleDeleteGuest"
    @export-csv="exportToCSV" 
    @refresh="handleRefresh" 
  />
    </div>
  </main>
</template>

<script>
import StatsCards from '../components/StatsCards.vue'
import GuestList from '../components/GuestList.vue'

export default {
  name: 'GuestListView',
  components: {
    StatsCards,
    GuestList
  },
  data() {
    return {
      showStats: false
    }
  },
  props: {
    guests: {
      type: Array,
      required: true
    },
    isRefreshing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    stats() {
      const total = this.guests.length
      const checkedIn = this.guests.filter(g => g.checkedIn).length
      const pending = total - checkedIn
      const percentage = total > 0 ? Math.round((checkedIn / total) * 100) : 0
      
      return {
        total,
        checkedIn,
        pending,
        percentage
      }
    }
  },
  methods: {
    handleCheckIn(guest) {
      this.$emit('check-in', guest)
    },

    handleRefresh() {
      this.$emit('refresh')
    },

    handleResetGuest(guest) {
      this.$emit('reset-guest', guest)
    },

    handleDeleteGuest(guest) {
      this.$emit('delete-guest', guest)
    },

    exportToCSV() {
      if (!this.guests || this.guests.length === 0) {
        alert('No guest data to export')
        return
      }

      // Create CSV headers
      const headers = ['First Name', 'Last Name', 'Company', 'Email', 'Checked In']
      
      // Create CSV data
      const csvData = this.guests.map(guest => {
        // Parse email from jsonData if available
        let email = ''
        try {
          const jsonData = JSON.parse(guest.jsonData || '{}')
          email = jsonData['main-mail'] || ''
        } catch (e) {
          email = ''
        }

        return [
          guest.firstName || '',
          guest.lastName || '',
          guest.company || '',
          email,
          guest.checkedIn ? 'Yes' : 'No'
        ]
      })

      // Convert to CSV string
      const csvContent = [
        headers.join(','),
        ...csvData.map(row => row.map(cell => `"${cell}"`).join(','))
      ].join('\n')

      // Create blob and download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      
      // Generate filename with timestamp
      const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-')
      link.setAttribute('href', url)
      link.setAttribute('download', `guests_${timestamp}.csv`)
      link.style.visibility = 'hidden'
      
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  emits: ['check-in', 'reset-guest', 'delete-guest', 'refresh']
}
</script>
